import api from "../index";

export const GetAlllogsApi = (Id, params) => api.get(`Admin/AuditLog-ByUserId/${Id}?${params}`);
